import React from 'react'
import { bounceIn } from 'react-animations'
import { Alert } from 'react-bootstrap'
import styled, { keyframes } from 'styled-components'

// animations
const BounceInAnimation = keyframes`${bounceIn}`
const Bounce = styled.div`
  animation: 1s ${BounceInAnimation};
  --animate-repeat: 1;
  --animate-duration: 2s;
`

const AlertDynamic = (props) => {
  const { msg } = props
  return (
    <Bounce>
      <Alert
        className="mb-0 mt-4 mx-4 text-center password-alert-custom"
      >
        {msg}
      </Alert>
    </Bounce>
  )
}

export default AlertDynamic
